import React from "react";
import { useTranslation } from "react-i18next";

interface ClientLogoProps {
  src?: string;
  alt?: string;
  className?: string;
}

const ClientLogo: React.FC<ClientLogoProps> = ({ src, alt, className }) => {
  const { t } = useTranslation();
  if (!src) return null;
  return (
    <div className={`flex items-center justify-center ${className || ""}`}>
      <img src={src} alt={alt || t("help.clientLogoAlt")} className="h-10 object-contain" />
    </div>
  );
};

export default ClientLogo;
